import { tryCatchHelper } from '../../../helpers';
import { TEACHER_CONST } from '../../auth/login/LoginReducer';
import { ACTIVO_DOCENTES } from '../../control_estudios/docentes/DocentesReducer';
import { oneEntidadesAction } from '../../entidad/entidades/EntidadesAction';
import { LOADING_ALL_ENTIDADES } from '../../entidad/entidades/EntidadesReducer';
import {
  allUsuEntidadesAction,
  setActivoUsuEntidadesAction,
} from '../../usuario/usu_entidades/UsuEntidadesAction';
import { ACTIVO_ENT_USUARIO } from '../usu_entidades/UsuEntidadesReducer';
import { oneUsuEntidadesService } from '../usu_entidades/UsuEntidadesService';
import {
  ACTIVO_USUARIOS,
  ALL_USUARIOS,
  GET_ENTIDADES_USUARIOS,
  LOADING_ALL_USUARIOS,
} from './UsuariosReducer';
import {
  allUsuariosService,
  deleteUsuariosService,
  oneUsuariosService,
  saveUsuariosService,
  sincronizarUsuariosService,
  updatePerfilUsuariosService,
  updateUsuariosService,
} from './UsuariosService';

export const allUsuariosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_USUARIOS, payload: true });
    const res = await allUsuariosService(params);
    dispatch({
      type: ALL_USUARIOS,
      payload: res.data,
    });
    dispatch({ type: LOADING_ALL_USUARIOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_USUARIOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveUsuariosAction = async (
  { dispatch, notify, isRoot },
  isUsuarios,
  usuEntidades,
  id,
  data,
  params,
) => {
  try {
    let res;
    if (id) {
      res = await updateUsuariosService(id, data);
    } else {
      res = await saveUsuariosService(data);
    }
    notify(res.data.message);

    if (id) {
      await setActivoUsuariosAction(
        dispatch,
        isUsuarios ? res.data.data : res.data.data.usuario,
      );
    }

    if (isUsuarios && isRoot) {
      await allUsuariosAction(dispatch, params);
    } else {
      if (id) {
        await setActivoUsuEntidadesAction(dispatch, {
          ...usuEntidades,
          estatus: res.data.data.entidad.estatus,
          usuario: res.data.data.usuario,
        });
      }

      await allUsuEntidadesAction(dispatch, {
        idEntidad: data.idEntidad,
        ...params,
      });
    }
    dispatch({ type: ALL_USUARIOS, payload: null });
    return res.data.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoUsuariosAction = async (dispatch, data) => {
  dispatch({
    type: ACTIVO_USUARIOS,
    payload: data,
  });
};

export const oneUsuariosAction = async (dispatch, id) => {
  try {
    const res = await oneUsuariosService(id);
    await setActivoUsuariosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const getEntidadesUsuariosAction = async (dispatch, user) => {
  try {
    dispatch({ type: LOADING_ALL_ENTIDADES, payload: true });
    dispatch({ type: GET_ENTIDADES_USUARIOS, payload: user.entidades });

    const entidad = user.entidades[0].entidad;
    await oneEntidadesAction(dispatch, entidad.id);
    dispatch({ type: LOADING_ALL_ENTIDADES, payload: false });

    const res = await oneUsuEntidadesService(user.entidades[0].id);
    if (res.status === 200) {
      dispatch({ type: ACTIVO_ENT_USUARIO, payload: res.data.data });

      if (user.rol === TEACHER_CONST) {
        dispatch({ type: ACTIVO_DOCENTES, payload: res.data.data });
      }
      return res.data.data;
    }
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const updatePerfilUsuariosAction = async (
  { dispatch, notify },
  id,
  data,
) => {
  try {
    const res = await updatePerfilUsuariosService(id, data);
    notify(res.data.message);
    return res.data.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteUsuariosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteUsuariosService(id);
    notify(res.data.message);
    await setActivoUsuariosAction(dispatch, null);
    await allUsuariosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const sincronizarAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_USUARIOS, payload: true });
    const res = await sincronizarUsuariosService(params);
    dispatch({ type: LOADING_ALL_USUARIOS, payload: false });
    return res.data.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_USUARIOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};
